import { useEffect, useState } from "react"
import  {useParams} from "react-router"
import { Link } from "react-router";
// import MenuCard from "./MenuCard"
import MenuCard from "./MenuCard"
export default function RestaurantMenu(){
    let {id} = useParams();
    const [RestData ,setRestData] = useState([]);
    useEffect (()=>{
      async  function fetchData(){
            const proxyServer ="https://cors-anywhere.herokuapp.com/corsdemo"
            const swiggyApi =`https://www.swiggy.com/dapi/menu/pl/search?lat=28.7040592&lng=77.1024901999999&restaurantId${id}`
            const response = await fetch(proxyServer+swiggyApi)
            const data = await response.json();
            const tempData = data?.data?.cards[5]?.groupedCard?.cardGroupMap?.REGULAR?.cards
            const filterData = tempData.filter((items)=>'title' in items?.card?.card)
            
            setRestData(filterData);
            
        }
        fetchData();
    },[])
    // console.log(RestData)
    return(

        <div>
            <div className="w-[80%] mx-auto mb-20">
                <p className="w-full text-center py-4 rounded-4xl text-2xl">Search for Dishes</p>
            </div>
        
        <div className="w-[80%] mx-auto mb-20">
            {

            RestData?.map((menuItems)=><MenuCard key={menuItems?.card?.card?.title} menuItems={menuItems?.card?.card}></MenuCard>)
        }

        </div>
        </div>
    )
}